import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface LinkedThemeBrand {
  readonly id: string;
  readonly name: string;
  readonly logoUrl?: string;
}

@Component({
  selector: 'tf-settings-theme-linked-brands-popover',
  imports: [TranslateModule],
  templateUrl: './theme-linked-brands-popover.component.html',
  styleUrl: './theme-linked-brands-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeLinkedBrandsPopoverComponent {
  readonly brands = input.required<readonly LinkedThemeBrand[]>();

  linkedBrandInitials(name: string): string {
    return name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');
  }
}
